// src/services/api/courierPerformance.js
import { apiClient } from './base';

/**
 * Get courier performance summary data for charts and cards
 * @param {Object} params - Query parameters
 * @param {string} params.groupBy - 'date' | 'week' | 'month' | 'shipping_zone' | 'district' | 'province' (required)
 * @param {string|number} params.shopId - Shop ID or 'all'
 * @param {string|number} params.businessCourierId - Business courier ID or 'all'
 * @param {string} params.dateFrom - Start date (YYYY-MM-DD)
 * @param {string} params.dateTo - End date (YYYY-MM-DD)
 * @returns {Promise<Object>} Summary data with grouped results and overall summary
 */
export const getCourierPerformanceSummary = async (params) => {
  try {
    const response = await apiClient.get('/courier-performance/summary', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get detailed courier performance data with order list
 * @param {Object} params - Query parameters
 * @param {string} params.groupBy - 'date' | 'week' | 'month' | 'shipping_zone' | 'district' | 'province' (required)
 * @param {string|number} params.shopId - Shop ID or 'all'
 * @param {string|number} params.businessCourierId - Business courier ID or 'all'
 * @param {string} params.dateFrom - Start date (YYYY-MM-DD)
 * @param {string} params.dateTo - End date (YYYY-MM-DD)
 * @param {number} params.page - Page number
 * @param {number} params.limit - Items per page
 * @param {string} params.status - Filter by 'delivered' | 'returned' | 'in_process'
 * @returns {Promise<Object>} Detailed data with pagination
 */
export const getCourierPerformanceDetails = async (params) => {
  try {
    const response = await apiClient.get('/courier-performance/details', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};